import { useMemo } from 'react';

import { useSpace } from '@/entities/teamspace';
import { useCurrentUser } from '@/entities/user/currentUser';

export const useIsSpaceOwner = () => {
  const { data: space } = useSpace();
  const { data: user } = useCurrentUser();

  return useMemo(
    () => space?.members.find((member) => member.email === user?.email)?.role === 'owner',
    [space?.members, user],
  );
};
